import React from 'react'
import { useTheme } from '@mui/system'
import HorizontalBarChart from './utils/HorizontalBarChart'
import { BarSeriesType } from '@mui/x-charts'
import { roundFloat } from '../../packages/utils/numberFormatters'
import { WarrantSubscriptionPeriod } from 'types/WarrantEntity'

export const WarrantCommitChart = ({
    isLeftAlign,
    subscriptionPeriod,
}: {
    isLeftAlign?: boolean
    subscriptionPeriod: WarrantSubscriptionPeriod
}) => {
    const theme = useTheme()
    const { commitments, guarantors } = subscriptionPeriod
    const notAssured = Math.max(0, 100 - +(commitments ?? 0) - +(guarantors ?? 0))

    const series: (Omit<BarSeriesType, 'type'> & { omit?: boolean })[] | null = [
        {
            label: 'Teckningsåtagande',
            data: [roundFloat(commitments === null ? 0 : +commitments, 4)],
            color: theme.palette.info.main,
        },
        {
            label: 'Garant',
            data: [roundFloat(guarantors === null ? 0 : +guarantors, 4)],
            color: theme.palette.info.light,
        },
        {
            label: 'Ej säkerställt',
            data: [roundFloat(notAssured, 4)],
            color: theme.palette.grey[200],
            omit: notAssured === 0,
        },
    ].filter((s) => !s.omit)

    return (
        <HorizontalBarChart
            isLeftAlign={isLeftAlign}
            labelValue={+(subscriptionPeriod.commitments ?? 0) + +(subscriptionPeriod.guarantors ?? 0)}
            series={series}
        />
    )
}
